import { render } from "./BarcodesComp.vue?vue&type=template&id=645171ad&scoped=true"
import script from "./BarcodesComp.vue?vue&type=script&lang=js"
export * from "./BarcodesComp.vue?vue&type=script&lang=js"

import "./BarcodesComp.vue?vue&type=style&index=0&id=645171ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645171ad"]])

export default __exports__